import type { Change, Inline } from '@gitbook/slate';

/**
 * Select the whole inline node.
 */
export function selectInline(change: Change, node: Inline) {
    const { selection } = change.value;
    // If the selection is expanded in the Node, don't change it
    if (selection.hasAnchorIn(node) && selection.isExpanded) {
        return;
    }
    // Else if it's a click, select the whole link
    change.moveAnchorToStartOf(node).extendToEndOf(node).focus();
}
